function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState } from 'react';
import styled from 'styled-components';
import CreatableSelect from 'react-select/creatable';
const CreatableSelectStyled = styled(CreatableSelect)`
  .multi-select-text-input__menu {
    z-index: 5;
  }
  .multi-select-text-input__control {
    background-color: #fff;
    border-width: 0px;
    box-shadow: none;
    outline: none;
    &:focus,
    &:hover {
      border-width: 0px;
      box-shadow: none;
      outline: none;
    }
  }
  .multi-select-text-input__multi-value__label {
    font-size: 12px;
  }
  .multi-select-text-input__input {
    font-size: 14px;
  }
`;
const components = {
  DropdownIndicator: null
};
const createOption = label => ({
  label,
  value: label
});
const MultiSelectTextInput = ({
  onChange,
  name,
  defaultOptions = [],
  validateField,
  setFieldError,
  ...rest
}) => {
  const [input, setInput] = useState('');
  const handleChange = data => {
    onChange(data || []);
  };
  const handleInputChange = input => {
    setInput(input);
  };
  const checkDuplicacy = (arr, input) => arr.findIndex(val => val.value === input.value) !== -1;
  const handleKeyDown = event => {
    if (!input) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        if (validateField && setFieldError) {
          let err = validateField(input);
          if (err) {
            setFieldError(name, err);
            return;
          } else {
            setFieldError(name);
          }
        } else if (setFieldError) {
          let err = checkDuplicacy([...defaultOptions], createOption(input));
          if (err) {
            setFieldError(name, 'Duplicate Values not allowed');
            return;
          }
        }
        onChange([...defaultOptions, createOption(input)]);
        setInput('');
        event.preventDefault();
        break;
      default:
        break;
    }
  };
  return /*#__PURE__*/React.createElement(CreatableSelectStyled, _extends({
    classNamePrefix: "multi-select-text-input",
    components: components,
    inputValue: input,
    isClearable: true,
    isMulti: true,
    menuIsOpen: false,
    onChange: handleChange,
    onInputChange: handleInputChange,
    onKeyDown: handleKeyDown,
    placeholder: "",
    value: defaultOptions
  }, rest));
};
export default MultiSelectTextInput;